<div class="o-grid o-grid--wrap">
	<div class="o-grid__cell o-grid__cell--w-fixed" style="position:absolute; left: 0;">
		<button id="selectTimeSlotPreviousPageButton" type="button" class="c-button c-button--tp c-button--icon" (click)="vm.setPreviousPage()">
			<i class="o-icon o-icon--angle u-no-mr" aria-hidden="true"></i>
		</button>
	</div>
	<div class="o-grid__cell" [ngClass]="{'u-no-pl': !$first, 'o-grid__cell--w-33': vm.pageSize === 3, 'o-grid__cell--w-25': vm.pageSize === 4, 'o-grid__cell--w-20': vm.pageSize === 5}" *ngFor="let date of vm.timeslots | startFrom:vm.currentPage*vm.pageSize | arrayLimitTo:vm.pageSize ; let $parentIndex=index ; let $first = first">
		<p class="c-text c-text--center c-text--bold c-text--lg">{{ date.date }}</p>
		<p class="c-text c-text--center c-text--gray">{{ date.name }}</p>
		<ul class="c-list u-ost-lg u-osb-lg">
			<li class="c-list__item" *ngFor="let slot of date.slots ; let $index=index ; let $last = last">
				<button id="selectTimeSlotButton{{$parentIndex}}-{{$index}}" type="button" style="border-radius: 0;" class="c-button c-button--fit c-button--narrow u-no-ph" [ngClass]="{'c-button--s1': vm.isSelected(slot), 'c-button--s6': !vm.isSelected(slot)}" (click)="vm.selectSlot(slot)" [ngStyle]="!$last && {'margin-bottom':'-1px','border-bottom':'none'}">{{ slot.start }} - {{ slot.end }}</button>
			</li>
		</ul>
	</div>
	<div class="o-grid__cell o-grid__cell--w-fixed" style="position:absolute; right: 0">
		<button id="selectTimeSlotNextPageButton" type="button" class="c-button c-button--tp c-button--icon" (click)="vm.setNextPage()">
			<i class="o-icon o-icon--angle-r u-no-mr" aria-hidden="true"></i>
		</button>
	</div>
</div>
